// Import the necessary App Check modules
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// Your Firebase config - this needs to be filled with your actual Firebase project details
const firebaseConfig = {
    apiKey: "AIzaSyA15epzq8fpUQlEJjtZJ83-buWK6MKP52Y",
    authDomain: "brewzwifi.firebaseapp.com",
    databaseURL: "https://brewzwifi-default-rtdb.firebaseio.com",
    projectId: "brewzwifi",
    storageBucket: "brewzwifi.firebasestorage.app",
    messagingSenderId: "439788128101",
    appId: "1:439788128101:web:560ab172395fa176b7c38c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check (in production)
if (process.env.NODE_ENV === 'production') {
  // Initialize App Check and set up the reCAPTCHA v3 provider with your site key
  const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider('6Lc0yBcsAAAAAMfwY1AdqQQ45VkQgCe4Wksx-VQY'),
    isTokenAutoRefreshEnabled: true
  });
} else {
  // For development environment, you can use this to bypass App Check
  // This should be removed in production
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// Initialize Firebase services
const auth = getAuth(app);
const firestore = getFirestore(app);

// Your existing helper functions
const formatPhoneNumber = (phoneNumber) => {
  // Remove any non-digit characters
  return phoneNumber.replace(/\D/g, '');
};

const handleFirestoreError = (error) => {
  console.error('Firestore Error:', error);
  
  // Handle specific Firestore errors
  if (error.code === 'permission-denied') {
    return 'You do not have permission to perform this action.';
  } else if (error.code === 'unavailable') {
    return 'The service is currently unavailable. Please try again later.';
  }
  
  return 'An error occurred while saving your data. Please try again.';
};

export { auth, firestore, formatPhoneNumber, handleFirestoreError };